module.exports = __webpack_public_path__ + "img/figure03.bc7c9993.png";